import React from 'react';

const GaleriaDeckTablonWpc = () => {
  const vistas = [
    { titulo: 'Vista Frontal', img: '/assets/img/productos/piso-deck-wpc/wpc-frente.png' },
    { titulo: 'Vista Lateral', img: '/assets/img/productos/piso-deck-wpc/wpc-lado.png' },
    { titulo: 'Vista Superior (Ancho)', img: '/assets/img/productos/piso-deck-wpc/wpc-ancho.png' }
  ];

  return (
    <section className="bg-light py-5 mb-1">
      <div className="container">
        <div className="section-heading text-center mb-5">
          <h2 className="h1 font-weight-800 mb-3">Detalle del Producto</h2>
          <p className="lead mx-auto" style={{ maxWidth: '600px' }}>
            Explora la estructura y el perfil de nuestros tablones.
          </p>
        </div>
        
        <div className="row justify-content-center align-items-stretch g-4">
          {vistas.map((vista, index) => (
            <div key={index} className="col-lg-4 col-md-6 d-flex">
              <div className="text-center w-100 d-flex flex-column">
                {/* Contenedor de imagen con fondo uniforme */}
                <div 
                  className="galeria-image-container rounded shadow-sm mb-3 flex-grow-1"
                  style={{
                    backgroundColor: '#E4E2DD',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    minHeight: '300px',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '';
                  }}
                >
                  <img 
                    src={vista.img} 
                    alt={vista.titulo} 
                    className="galeria-image"
                    style={{
                      maxWidth: '90%',
                      maxHeight: '90%',
                      width: 'auto',
                      height: 'auto',
                      objectFit: 'contain',
                      transition: 'transform 0.5s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  />
                </div>
                
                {/* Título */}
                <h5 className="h6 font-weight-700 text-uppercase letter-spacing-1 mb-0" style={{ color: '#333' }}>
                  {vista.titulo}
                </h5>
              </div>
            </div>
          ))}
        </div>
        
        {/* Botón de CTA */}
        {/*}
        <div className="text-center mt-5 pt-4">
          <a 
            href="#contacto" 
            className="btn btn-primary btn-lg px-5 py-3 font-weight-700 text-uppercase"
            style={{
              backgroundColor: '#1a365d',
              borderColor: '#1a365d',
              fontSize: '1.1rem',
              letterSpacing: '1px',
              transition: 'all 0.3s ease',
              minWidth: '200px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#0f2547';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(26, 54, 93, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#1a365d';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '';
            }}
          >
            COTIZA AHORA
          </a>
        </div>
        */}
      </div>

      {/* Estilos inline para responsive */}
      <style>{`
        @media (max-width: 768px) {
          .galeria-image-container {
            min-height: 240px !important;
            padding: 1.5rem !important;
          }
        }
        
        @media (min-width: 992px) {
          .galeria-image-container {
            min-height: 340px !important;
          }
        }
        
        @media (min-width: 1200px) {
          .galeria-image-container {
            min-height: 380px !important;
          }
        }
        
        /* Asegurar que las columnas tengan misma altura en desktop */
        @media (min-width: 768px) {
          .d-flex > .text-center {
            height: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default GaleriaDeckTablonWpc;